export default {
    model: {
        email: {
            label: "E-mail",
            placeholder: "Nom ou adresse courriel du délégué",
            notFound: "Utilisateurs introuvables"
        },
        start_on: {
            label: "Date de début",
            placeholder: "Date de début de la délégation"
        },
        end_on: {
            label: "Date de fin",
            placeholder: "Facultatif"
        },
        accept: {
            tip: "En déléguant votre responsabilité d'approbation, vous certifiez que vous assumez l'entière responsabilité de toutes les commandes approuvées par votre délégué.",
            label: "J'accepte"
        }
    },
    buttons: {
        submit: {
            cta: "Confirmer",
            processing: "Économie"
        },
        close: {
            cta: "Annuler"
        }
    },
    saved: "Enregistré"
}